import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CertidoesRelatorioComponent } from './certidoes-relatorio.component';

@NgModule({
  declarations: [CertidoesRelatorioComponent],
  exports: [CertidoesRelatorioComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PoModule,
    FormsModule
  ]
})
export class CertidoesRelatorioModule {}
